import { render, staticRenderFns } from "./VaccinationAnalysisTableBody.vue?vue&type=template&id=6a8dadc7&scoped=true&"
import script from "./VaccinationAnalysisTableBody.vue?vue&type=script&lang=ts&"
export * from "./VaccinationAnalysisTableBody.vue?vue&type=script&lang=ts&"
import style0 from "./VaccinationAnalysisTableBody.vue?vue&type=style&index=0&id=6a8dadc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8dadc7",
  null
  
)

export default component.exports